import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Spacer,
  Spinner,
  Text,
  VStack,
  useMediaQuery,
  HStack,
  Image,
  Pressable,
} from "native-base";
import CryptoJS from "crypto-js";
import CommonHeading from "../../../components/headings";
import ToggleButton from "../../../components/toggle";
import Events from "../../../containers/events";
import ContainerCards from "../../../components/cards";
import { COLORS } from "../../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import NoDataFound from "../../../components/noDataFound";
import CustomButton from "../../../components/button";
import { useSelector } from "react-redux";
import { PackagesCard } from "../../../containers/packages";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../utils/fonts";
import {
  addIconSVG,
  filterSVG,
  photoSelectedTickSVG,
  photoTickIconSVG,
  uploadIconWhiteSVG,
} from "../../../utils/svg";
import CommonAvatar from "../../../components/avatar";
import CustomModal from "../../../components/modal";
import MobileModelSheet from "../../../components/actionSheet";
import InputField from "../../../components/input";
import NewTextAreaField from "../../../components/textArea/newTextArea";
import FileUploader from "../../../containers/fileUpload";
import ViewUploadImageCards from "../../../containers/viewUploadImageCards";
import DividerLine from "../../../components/divider";
import Svg from "react-native-svg";
import { LoaderAnimation } from "../../../components/spinner";
import { Toaster } from "../../../components/toaster";
import { uploadFileAPI } from "../../../api/apis/workflow";
import {
  addPackagesAPI,
  deleteExpenseAPI,
  getExpenseListingAPI,
  getVendorEventsAPI,
  updatePackagesAPI,
} from "../../../api/apis/vendor";
import config from "../../../utils/config";
import PopOverModal from "../../../components/popover";
import AttachmentsCards from "../../../containers/attachmentCards";
import { uploadMISFileAPI } from "../../../api/apis/graphs";

const VendorLandingPageEvents = ({ setActiveButton }) => {
  const childref = useRef();
  const childRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [tabActiveButton, setTabActiveButton] = useState("Current");
  const options = ["Current", "Completed", "Rejected"];
  const [tabPackageActiveButton, setTabPackageActiveButton] =
    useState("Pending");
  const packageOptions = ["Pending", "Approved"];

  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isExpenseLoading, setIsExpenseLoading] = useState(true);
  const [items, setItems] = useState([]);
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [eventActiveTab, setEventActiveTab] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState("");
  const [packages, setPackages] = useState({
    package_name: "",
    description: "",
  });
  const [editPackage, setEditPackage] = useState({});
  const [selectedActionName, setSelectedActionName] = useState("");
  const toaster = Toaster();
  const [forceRemount, setForceRemount] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [uploadImages, setUploadImages] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showPopOverModal, setShowPopOverModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    types: [],
    selected: "",
  });
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [expenseData, setExpenseData] = useState([]);

  useEffect(() => {
    let tabItem = sessionStorage.getItem("package");
    if (tabItem === "package_approved") {
      sessionStorage.setItem("package", "");
      setTabPackageActiveButton("Approved");
    }
    let tab = "MICE";
    if (activeTab === "event") {
      tab = "Events";
    } else if (activeTab === "packages") {
      tab = "Packages";
    }
    setEventActiveTab(tab);
    if (tab !== "Packages") {
      getEventList();
      getExpenseListing();
    }
  }, [activeTab]);

  const getEventList = async (
    status = tabActiveButton,
    page_no = 1,
    per_page = 10,
    add = true
  ) => {
    setIsLoading(true);
    let res = await getVendorEventsAPI(
      page_no,
      per_page,
      activeTab.toLowerCase(),
      status.toLowerCase()
    );
    if (res.error) {
      toaster(res.message, "error", "error");
      return [];
    } else {
      if (add) {
        setItems(res.data.data.data?.[0]?.events);
      } else if (!add) {
        setItems([...items, ...res.data.data.data?.[0]?.events]);
      }
      setCurrentPage(res.data.data.data?.[0]?.pagination?.[0]?.page + 1);
      setPagination(res.data.data.data?.[0]?.pagination?.[0]?.total);
      setIsLoading(false);
      return res.data.data.data?.[0]?.events;
    }
  };

  const getExpenseListing = async (year = "") => {
    setIsExpenseLoading(true);
    let res = await getExpenseListingAPI(activeTab, year);
    if (res.error) {
      toaster(res.message, "error", "error");
      return [];
    } else if (res?.data?.data?.data) {
      let result = [],
        filterDates = { ...filterOptions };
      filterDates.types = [];
      filterDates.selected = year;
      res?.data?.data?.data?.list_expense?.length > 0 &&
        res.data.data.data?.list_expense.map((item) => {
          result.push({
            id: item._id,
            document_name: item.doc_type,
            size: item.file_size,
            file_name: item.file_name,
            time: item.added_at,
          });
        });
      res?.data?.data?.data?.years?.length > 0 &&
        res?.data?.data?.data?.years?.map((item) => {
          filterDates.types.push({
            text: item,
            value: "date_" + item,
          });
        });
      setFilterOptions(filterDates);
      setExpenseData(result);
    }
    setIsExpenseLoading(false);
  };

  const openModal = () => {
    // selectedActionName === "upload_expenses" && scrollToTop();
    setShowModal(true);
    setSelectedImageIndex("");
    setForceRemount(!forceRemount);
  };

  const closeModal = () => {
    setForceRemount(!forceRemount);
    setFiles([]);
    setSelectedFiles([]);
    setUploadImages("");
    setEditPackage({});
    setPackages({
      package_name: "",
      description: "",
    });
    setShowModal(false);
  };

  const openPopOverModal = () => {
    setShowPopOverModal(true);
  };

  const closePopOverModal = () => {
    setFilterOptions({ ...filterOptions, selected: [] });
    setShowPopOverModal(false);
  };

  const handleFilesSelect = (files) => {
    setSelectedFiles(files);
  };

  const handleSelectedImages = (index) => {
    setFiles([]);
    setUploadImages("");
    let selectInd = [];
    if (selectedImageIndex.length > 0 && selectedImageIndex.includes(index))
      selectInd = selectedImageIndex.filter((image) => image !== index);
    else selectInd = [index];
    setSelectedImageIndex(selectInd);
  };

  const onInputChange = (e, eName) => {
    let data = packages;
    data[eName] = e.target.value;
    setPackages(data);
  };

  const uploadFilesToServer = async (data, type, event) => {
    let docs = [];
    let res = await uploadFileAPI(data, type, event);
    res.map((item) => {
      if (item.error) {
        toaster("Upload file failed", "error", "error");
        return;
      }
      if (item.data.data.data) {
        docs.push({
          file_size: item.data.data.data.file_size.toString(),
          file_name: item.data.data.data.file_name,
          media_id: item.data.data.data.media_id,
          name: item.data.data.data.doc_type,
        });
      }
    });
    return docs;
  };

  const handleEditPackage = (item) => {
    setSelectedActionName("edit_package");
    setEditPackage(item);
    setFiles([]);
    setFiles(item["banner_image"]);
    openModal();
  };

  const handleImageChange = (files) => {
    setFiles(files);
    const imageUrls = Array.from(files).map((file) =>
      URL.createObjectURL(file)
    );
    setUploadImages(imageUrls);
  };

  const onDeleteImage = (ind) => {
    setUploadImages("");
    setFiles([]);
  };

  const handleOptionChange = (e) => {
    let selectedValue = { ...filterOptions };
    // if (
    //   filterOptions.selected.length === 0 ||
    //   !filterOptions.selected.includes(e.target.value)
    // ) {
    //   selectedValue = {
    //     ...filterOptions,
    //     selected: [...filterOptions.selected, e.target.value],
    //   };
    // } else {
    //   selectedValue = {
    //     ...filterOptions,
    //     selected: filterOptions.selected.filter(
    //       (item) => item !== e.target.value
    //     ),
    //   };
    // }
    selectedValue.selected = parseInt(e.target.value);
    setFilterOptions(selectedValue);
  };

  const getUploadedTime = (time) => {
    const isoString = time.toISOString();
    const offset = (time.getTimezoneOffset() / 60).toString().padStart(2, "0");
    const offsetString =
      (time.getTimezoneOffset() > 0 ? "-" : "+") + offset + ":00";
    const formattedDateTime = isoString.replace("Z", offsetString);
    return formattedDateTime;
  };

  const getPopupModalTitle = () => {
    if (selectedActionName === "add_package")
      return <Text>Create Packages</Text>;
    else if (selectedActionName === "edit_package")
      return <Text>Edit Package</Text>;
    else if (selectedActionName === "upload_expenses")
      return <Text>Upload Expenses</Text>;
    else if (MobileWindow && selectedActionName === "filter_expenses")
      return <Text>Filter</Text>;
  };

  const getPopupModalChildren = () => {
    if (selectedActionName === "upload_expenses") {
      return (
        <FileUploader
          files={selectedFiles}
          show={true}
          setFiles={handleFilesSelect}
          accept={["xls", "xlsx"]}
          types=".xls, .xlsx"
          href={
            activeTab === "event"
              ? config.eventExpenseUploadurl
              : activeTab === "mice" && config.miceExpenseUploadurl
          }
          templates
          forceRemount={forceRemount}
          // images={true}
        />
      );
    } else if (selectedActionName === "filter_expenses") {
      return filterOptions.types.map((item) => {
        return (
          <HStack
            space={1.5}
            key={item.text}
            pr={3}
            className="radio-btns"
            alignItems={"center"}
          >
            <input
              type="radio"
              value={item.text}
              checked={filterOptions.selected == item.text}
              onChange={handleOptionChange}
              className="radio-btns"
            />
            <Text
              color={COLORS.PARTNERS_HEADING_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
              pt="13px"
              mb={2}
              width={"100%"}
            >
              {item.text}
            </Text>
          </HStack>
        );
      });
    } else
      return (
        <HStack
          width={"100%"}
          space={8}
          direction={MobileWindow ? "column" : "row"}
        >
          <VStack space={5} width={!MobileWindow && "49%"}>
            <Box>
              <Text
                fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                mb={2}
              >
                Package Details
              </Text>
              <Box mb={3}>
                <InputField
                  name="package_name"
                  value={
                    selectedActionName === "edit_package" &&
                    editPackage["package_name"]
                      ? editPackage["package_name"]
                      : ""
                  }
                  label="Package Name"
                  placeholder="Enter Package Name"
                  onChange={onInputChange}
                  forceRemount={forceRemount}
                />
              </Box>
              <Box>
                <NewTextAreaField
                  name="description"
                  value={
                    selectedActionName === "edit_package" &&
                    editPackage["description"]
                      ? editPackage["description"]
                      : ""
                  }
                  onChange={onInputChange}
                  label="Package Description"
                  placeholder="Enter Package Description"
                  forceRemount={forceRemount}
                  ref={childRef}
                />
              </Box>
            </Box>
            {!MobileWindow && (
              <Box>
                <Text
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                >
                  Select Dummy Banner Placeholder
                </Text>
                <HStack space={3} mt={4}>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner1url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(1);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(1)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner2url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(2);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(2)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                  <Box width={"100px"} height={"80px"}>
                    <Image
                      src={config.bucketPath + config.dummyBanner3url}
                      width={"100%"}
                      height={"100%"}
                      resizeMode="stretch"
                    />
                    <Pressable
                      onPress={() => {
                        handleSelectedImages(3);
                      }}
                      zIndex="99"
                      position="absolute"
                      right={0}
                      p={0.5}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginTop: MobileWindow ? "3px" : 0,
                        backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                      }}
                    >
                      <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                        {selectedImageIndex.length > 0 &&
                        selectedImageIndex.includes(3)
                          ? photoSelectedTickSVG
                          : photoTickIconSVG}
                      </Svg>
                    </Pressable>
                  </Box>
                </HStack>
              </Box>
            )}
          </VStack>
          <Box width={!MobileWindow && "48%"}>
            <Text
              fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              // mb={2}
            >
              Upload Banner Image
            </Text>
            <FileUploader
              files={files}
              show={false}
              setFiles={handleImageChange}
              accept={["png", "jpg", "jpeg"]}
              types={".png, .jpg, .jpeg"}
              imageRestriction={true}
              isDisabled={selectedImageIndex.length > 0 && true}
              forceRemount={forceRemount}
            />
            {uploadImages && (
              <HStack flex={1} flexWrap={"wrap"}>
                <ViewUploadImageCards
                  ind={0}
                  url={uploadImages}
                  onDeleteImage={onDeleteImage}
                />
              </HStack>
            )}
            <Text
              fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
              color={COLORS.LABEL_TEXT_COLOR}
            >
              NOTE: Preferable banner size 250X360px
            </Text>
          </Box>
          {MobileWindow && (
            <Box>
              <HStack
                alignItems={"center"}
                justifyContent={"space-between"}
                mb={5}
              >
                <Box width={"43%"}>
                  <DividerLine direction="horizontal" />
                </Box>
                <Text
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  color={COLORS.PACKAGE_DETAILS_TEXT_COLOR}
                >
                  or
                </Text>
                <Box width={"43%"}>
                  <DividerLine direction="horizontal" />
                </Box>
              </HStack>
              <Text
                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              >
                Select Dummy Banner Placeholder
              </Text>
              <HStack mt={4} flexWrap={"wrap"}>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner1url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(1);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(1)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner2url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(2);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(2)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
                <Box width={"100px"} height={"80px"} mr={3} mb={3}>
                  <Image
                    src={config.bucketPath + config.dummyBanner3url}
                    width={"100%"}
                    height={"100%"}
                    resizeMode="stretch"
                  />
                  <Pressable
                    onPress={() => {
                      handleSelectedImages(3);
                    }}
                    zIndex="99"
                    position="absolute"
                    right={1}
                    p={0.5}
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: MobileWindow ? "3px" : 0,
                      backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
                    }}
                  >
                    <Svg width={"27"} height={"27"} viewBox={`0 0 47 47`}>
                      {selectedImageIndex.length > 0 &&
                      selectedImageIndex.includes(3)
                        ? photoSelectedTickSVG
                        : photoTickIconSVG}
                    </Svg>
                  </Pressable>
                </Box>
              </HStack>
            </Box>
          )}
        </HStack>
      );
  };

  const modalFooter = () => {
    if (selectedActionName === "add_package")
      return (
        <Box width={MobileWindow && "100%"}>
          <CustomButton
            onPress={async () => {
              LoaderAnimation.show();
              if (
                packages["description"] &&
                packages["description"].length > 5000
              ) {
                toaster(
                  "Please enter package description less than 5000 characters",
                  "error",
                  "error"
                );
                LoaderAnimation.hide();
                return;
              }
              if (
                packages["package_name"] &&
                packages["package_name"].length > 500
              ) {
                toaster(
                  "Please enter package name less than 500 characters",
                  "error",
                  "error"
                );
                LoaderAnimation.hide();
                return;
              }
              if (
                (files.length > 0 || selectedImageIndex.length > 0) &&
                packages["package_name"] &&
                packages["description"]
              ) {
                let docs = [];
                if (files.length > 0)
                  docs = await uploadFilesToServer(files, "image", "image");
                else if (selectedImageIndex.length > 0) {
                  let image = "",
                    name = "";
                  if (selectedImageIndex.includes(1)) {
                    image = config.dummyBanner1url;
                    name = "Dummy Banner-Package_1.png";
                  } else if (selectedImageIndex.includes(2)) {
                    image = config.dummyBanner2url;
                    name = "Dummy Banner-Package_2.png";
                  } else if (selectedImageIndex.includes(3)) {
                    image = config.dummyBanner3url;
                    name = "Dummy Banner-Package_3.png";
                  }
                  docs.push({
                    file_size: "10000",
                    media_id: "662b4c87cd42d078129e64f9",
                    name: name,
                    file_name: image,
                  });
                }
                if (docs) {
                  let payload = {
                    package_name: packages["package_name"],
                    description: packages["description"],
                    banner_image: docs,
                  };
                  let res = await addPackagesAPI(payload);
                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster("Package Added Successfully", "success", "success");
                    childref.current.getPackagesListing();
                    closeModal();
                  }
                }
              } else toaster("Enter all the details", "error", "error");
              LoaderAnimation.hide();
            }}
            text="Create"
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      );
    else if (selectedActionName === "edit_package") {
      return (
        <Box width={MobileWindow && "100%"}>
          <CustomButton
            onPress={async () => {
              LoaderAnimation.show();
              let description = childRef.current.onSubmitInput();
              if (
                files.length > 0 &&
                editPackage["package_name"] &&
                description["value"]
              ) {
                let docs = [];
                if (files[0].lastModified) {
                  docs = await uploadFilesToServer(files, "image", "image");
                } else {
                  docs = files;
                }
                if (docs) {
                  let payload = {
                    package_name: editPackage["package_name"],
                    description: description["value"],
                    banner_image: docs,
                  };
                  let res = await updatePackagesAPI(
                    editPackage["_id"],
                    payload
                  );

                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster(
                      "Package Updated Successfully",
                      "success",
                      "success"
                    );
                    childref.current.getPackagesListing();
                    closeModal();
                  }
                }
              } else toaster("Enter all the details", "error", "error");
              LoaderAnimation.hide();
            }}
            text="Update"
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      );
    } else if (selectedActionName === "upload_expenses") {
      return (
        <Box width={MobileWindow && "100%"}>
          <CustomButton
            onPress={async () => {
              LoaderAnimation.show();
              if (selectedFiles.length > 0) {
                let docs = await uploadFilesToServer(
                  selectedFiles,
                  "file",
                  activeTab
                );
                if (docs) {
                  let payload = {
                    documents: [
                      {
                        doc_type: docs[0]?.name,
                        file_size: docs[0]?.file_size,
                        file_name: docs[0]?.file_name,
                        media_id: docs[0]?.media_id,
                        added_by: userInfo?.user_id,
                        uploaded_time: getUploadedTime(new Date()),
                      },
                    ],
                  };
                  let res = await uploadMISFileAPI(payload, activeTab);
                  if (res.error) {
                    toaster(res.message, "error", "error");
                    LoaderAnimation.hide();
                    return;
                  } else {
                    toaster(
                      "Expenses Updated Successfully",
                      "success",
                      "success"
                    );
                    getExpenseListing();
                    closeModal();
                  }
                }
              } else toaster("Upload a file", "error", "error");
              LoaderAnimation.hide();
            }}
            text="Upload"
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      );
    }
  };

  const fetchData = async () => {
    const response = await getEventList(
      tabActiveButton.toLowerCase(),
      currentPage,
      10,
      false
    );
  };

  return (
    <>
      {eventActiveTab !== "Packages" ? (
        <CommonHeading text={eventActiveTab} />
      ) : (
        <HStack justifyContent={"space-between"} mb={"25px"}>
          <CommonHeading text={eventActiveTab} />
          {
            !MobileWindow && (
              <CustomButton
                width="fit-content"
                text="Upload Package"
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                endIcon={uploadIconWhiteSVG}
                onPress={() => {
                  setSelectedActionName("add_package");
                  openModal();
                }}
              />
            )
            // : (
            //   <CommonAvatar
            //     width={MobileWindow ? "35px" : "50px"}
            //     height={MobileWindow ? "35px" : "50px"}
            //     bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
            //     svg={addIconSVG}
            //     svgwh="24"
            //     view="0 0 24 24"
            //     onPress={openModal}
            //     touchable={true}
            //   />
            // )
          }
        </HStack>
      )}
      {eventActiveTab !== "Packages" ? (
        <>
          <VStack space={5} mt={2}>
            <ToggleButton
              options={options}
              activeButton={tabActiveButton}
              setActiveButton={(value) => {
                setCurrentPage(1);
                setItems([]);
                setTabActiveButton(value);
                getEventList(value.toLowerCase(), 1, 10, true);
              }}
            />
            {isLoading ? (
              <Box mt={10} flex={1} alignItems="center" justifyContent="center">
                <Spinner color={COLORS.THEME_COLOR} size="lg" />
              </Box>
            ) : (
              <>
                <VStack space={4}>
                  {items && items.length > 0 ? (
                    items.map((item) => {
                      let event_date = item.from_date;
                      const dateObj = new Date(event_date);
                      const options = { month: "short" };
                      const month = dateObj.toLocaleDateString(
                        "en-US",
                        options
                      );
                      const day = dateObj.getDate();
                      let review = item?.average_rating
                        ? parseFloat(item?.average_rating.toFixed(1))
                        : 0;

                      return MobileWindow ? (
                        <Link
                          style={{ textDecoration: "none" }}
                          to={"/event-detail"}
                        >
                          <ContainerCards
                            width="100%"
                            height={"auto"}
                            minH="113px"
                            background={COLORS.WHITE_COLOR}
                            justifyContent="center"
                          >
                            <Events
                              events={item}
                              eventDate={day}
                              eventMonth={month}
                              eventName={item.event_name}
                              images={item?.image_count}
                              ratings={review}
                              status={item.status}
                              tabActiveButton={tabActiveButton}
                              vendor
                              onEventDeleted={() => {
                                getEventList(tabActiveButton?.toLowerCase(), 1, 10, true);
                              }}
                            />
                          </ContainerCards>
                        </Link>
                      ) : (
                        <ContainerCards
                          width="100%"
                          height={"auto"}
                          minH="113px"
                          background={COLORS.WHITE_COLOR}
                          justifyContent="center"
                        >
                          <Events
                            events={item}
                            eventDate={day}
                            eventMonth={month}
                            eventName={item.event_name}
                            images={item?.image_count}
                            ratings={review}
                            status={item.status}
                            tabActiveButton={tabActiveButton}
                            vendor
                            onEventDeleted={() => {
                              getEventList(tabActiveButton?.toLowerCase(), 1, 10, true);
                            }}
                          />
                        </ContainerCards>
                      );
                    })
                  ) : (
                    <NoDataFound
                      dataName={
                        eventActiveTab === "Events" ? "event" : eventActiveTab
                      }
                      events={true}
                    />
                  )}
                </VStack>

                <Box mt={4} alignItems="center" justifyContent="center">
                  {items &&
                    items.length > 0 &&
                    !isNaN(pagination) &&
                    pagination > items.length && (
                      <CustomButton text="Load More" onPress={fetchData} />
                    )}
                </Box>
              </>
            )}
            <HStack
              mt={MobileWindow ? 2 : 8}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <CommonHeading
                text={`Upload ${
                  activeTab === "event"
                    ? "Event"
                    : activeTab === "mice" && "MICE"
                } Expenses`}
                fontSize={
                  MobileWindow
                    ? COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE
                    : undefined
                }
              />
              <HStack alignItems={"center"} space={4}>
                {filterOptions.types.length > 0 &&
                  (!MobileWindow ? (
                    <PopOverModal
                      isOpen={showPopOverModal}
                      onClose={closePopOverModal}
                      onOpenPress={() => {
                        setSelectedActionName("filter_expenses");
                        openPopOverModal();
                      }}
                      type="filter_expenses"
                      svg={
                        <Svg width="24" height="24" viewBox="0 0 24 24">
                          {filterSVG}
                        </Svg>
                      }
                      body={getPopupModalChildren()}
                      footer={
                        <HStack
                          mb={3}
                          justifyContent={"space-between"}
                          width={"100%"}
                        >
                          <CustomButton
                            text="No Filter"
                            isOutline
                            bgColor={COLORS.BLACK_COLOR}
                            textColor={COLORS.BLACK_COLOR}
                            onPress={() => {
                              setFilterOptions({
                                ...filterOptions,
                                selected: "",
                              });
                              getExpenseListing();
                              closePopOverModal();
                            }}
                          />
                          <CustomButton
                            text="Apply"
                            onPress={() => {
                              getExpenseListing(filterOptions.selected);
                              closePopOverModal();
                            }}
                          />
                        </HStack>
                      }
                    />
                  ) : (
                    <div
                      onClick={() => {
                        setSelectedActionName("filter_expenses");
                        openPopOverModal();
                      }}
                      style={{ marginTop: "8px" }}
                    >
                      <Svg width="24" height="24" viewBox="0 0 24 24">
                        {filterSVG}
                      </Svg>
                      {showPopOverModal && (
                        <MobileModelSheet
                          isOpen={showPopOverModal}
                          onClose={closePopOverModal}
                          header={getPopupModalTitle()}
                          body={getPopupModalChildren()}
                          footer={
                            <HStack
                              mb={3}
                              justifyContent={"space-between"}
                              width={"100%"}
                            >
                              <CustomButton
                                text="No Filter"
                                isOutline
                                bgColor={COLORS.BLACK_COLOR}
                                textColor={COLORS.BLACK_COLOR}
                                onPress={() => {
                                  setFilterOptions({
                                    ...filterOptions,
                                    selected: "",
                                  });
                                  getExpenseListing();
                                  closePopOverModal();
                                }}
                              />
                              <CustomButton
                                text="Apply"
                                onPress={() => {
                                  getExpenseListing(filterOptions.selected);
                                  closePopOverModal();
                                }}
                              />
                            </HStack>
                          }
                        />
                      )}
                    </div>
                  ))}
                <CommonAvatar
                  width={MobileWindow ? "35px" : "50px"}
                  height={MobileWindow ? "35px" : "50px"}
                  bgcolor={COLORS.TABS_ACTIVE_BORDER_COLOR}
                  svg={addIconSVG}
                  svgwh="24"
                  view="0 0 24 24"
                  onPress={() => {
                    setSelectedActionName("upload_expenses");
                    openModal();
                  }}
                  touchable={true}
                />
              </HStack>
            </HStack>
            {isExpenseLoading ? (
              <Box mt={10} flex={1} alignItems="center" justifyContent="center">
                <Spinner color={COLORS.THEME_COLOR} size="lg" />
              </Box>
            ) : expenseData.length > 0 ? (
              expenseData.map((item) => {
                return (
                  <AttachmentsCards
                    fileName={item.document_name}
                    fileSize={item.size}
                    path={config.bucketPath + item.file_name}
                    timeline={item.time}
                    attachments={true}
                    translateY={"-24px"}
                    height="fit-content"
                    minW="300px"
                    color={COLORS.WHITE_COLOR}
                    border={false}
                    id={item.id}
                    dashboard
                    deleteIcon
                    onDeleteFile={async (id) => {
                      LoaderAnimation.show();
                      setSelectedActionName("delete_file");
                      let res = await deleteExpenseAPI(id);
                      if (res.error) {
                        toaster(res.message, "error", "error");
                        LoaderAnimation.hide();
                        return;
                      } else {
                        toaster(
                          "File Deleted Successfully",
                          "success",
                          "success"
                        );
                        getExpenseListing();
                        closeModal();
                      }
                      LoaderAnimation.hide();
                      closeModal();
                    }}
                  />
                );
              })
            ) : (
              <NoDataFound dataName="document" events={true} />
            )}
          </VStack>
        </>
      ) : (
        <>
          <ToggleButton
            options={packageOptions}
            activeButton={tabPackageActiveButton}
            setActiveButton={(value) => {
              if (value === "Pending") {
                setActiveButton("pending");
              } else if (value === "Approved") {
                setActiveButton("package_approved");
              }
              setTabPackageActiveButton(value);
            }}
          />
          <Box mt={"27px"}>
            <PackagesCard
              handleEditPackage={handleEditPackage}
              ref={childref}
              activeButton={
                tabPackageActiveButton === "Pending"
                  ? "pending"
                  : tabPackageActiveButton === "Approved" && "package_approved"
              }
            />
          </Box>
        </>
      )}
      {selectedActionName !== "filter_expenses" &&
        (!MobileWindow ? (
          <CustomModal
            isOpen={showModal}
            onClose={closeModal}
            header={getPopupModalTitle()}
            body={getPopupModalChildren()}
            footer={modalFooter()}
            width={"70%"}
            top={selectedActionName === "add_package" ? "150px" : "150px"}
            fixedPosition={selectedActionName === "upload_expenses" && true}
            fixedTop={
              selectedActionName === "upload_expenses" ? 150 : undefined
            }
          />
        ) : (
          <MobileModelSheet
            isOpen={showModal}
            onClose={closeModal}
            header={getPopupModalTitle()}
            body={getPopupModalChildren()}
            footer={modalFooter()}
          />
        ))}
    </>
  );
};

export default VendorLandingPageEvents;
